/**
 * Listing-page secondary actions: icon-only 3-dot trigger + Popup ActionList.
 *
 * Primary create/new stays a visible Button. Every other header action goes
 * behind this menu. See Product KB listing-header-secondary-actions.
 */
import React, { useCallback, useRef, useState } from 'react';
import { Button } from '@ui/atoms/Button';
import { Popup } from '../../Popup';
export function ListingHeaderMoreMenu({ items, label }) {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const handleToggle = useCallback(() => {
        setOpen((prev) => !prev);
    }, []);
    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);
    if (items.length === 0)
        return null;
    return (React.createElement("div", { className: "header__more" },
        React.createElement(Button, { ref: anchorRef, type: "button", variant: "default", title: label, "aria-label": label, "aria-haspopup": "true", "aria-expanded": open, "data-testid": "listing-header-more", onClick: handleToggle },
            React.createElement("i", { className: "fa-light fa-ellipsis", "aria-hidden": "true" })),
        React.createElement(Popup, { anchor: anchorRef.current, show: open, onClose: handleClose, position: "bottom-right" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.ActionList, { padded: true }, items.map((item) => (React.createElement("a", { key: item.href, href: item.href, className: "qmb-ui-button", onClick: handleClose, "data-method": item.method, "data-confirm": item.confirm }, item.label))))))));
}
